import { fetch } from '@atlassian/eoc-fetch';

import {
	type CustomRoleFormValues,
	type CustomRoleResponse,
	type CustomRolesListResponse,
	type PermissionsResponse,
} from '../../../common/types';

export const getPermissionsEndpoint = () => fetch<PermissionsResponse>(`/v1/users/permissions`);

export const createCustomRoleEndpoint = (newCustomRole: CustomRoleFormValues) =>
	fetch<CustomRoleResponse>(`/v1/users/roles`, {
		method: 'POST',
		body: newCustomRole,
	});

export const editCustomRoleEndpoint = (updatedCustomRole: CustomRoleResponse) => {
	const { id } = updatedCustomRole;
	return fetch<CustomRoleResponse>(`/v1/users/roles/${id}`, {
		method: 'PATCH',
		body: updatedCustomRole,
	});
};

export const deleteCustomRoleEndpoint = (id: string) => {
	return fetch<{ success: boolean }>(`/v1/users/roles/${id}`, {
		method: 'DELETE',
	});
};

export const getCustomRolesListEndpoint = () => fetch<CustomRolesListResponse>(`/v1/users/roles`);
